<app-public-nav></app-public-nav>
<router-outlet></router-outlet>
<footer class="gov-footer">
  <div class="gov-footer-inner">
    <div class="gov-footer-grid">
      <div class="gov-footer-org">
        <div class="gov-footer-sealz">
          <img src="images/logo2.png" alt="" height="50">
        </div>
        <div>
          <div class="gov-footer-org-name">สำนักงานมาตรฐานสินค้าเกษตรและอาหารแห่งชาติ</div>
          <div class="gov-footer-org-subname">(มกอช.)</div>
          <p class="gov-footer-org-address">50 ถนนพหลโยธิน แขวงลาดยาว เขตจตุจักร<br>กรุงเทพมหานคร 10900</p>
        </div>
      </div>
      <div class="gov-footer-col">
        <div class="gov-footer-col-head">ติดต่อเรา</div>
        <ul>
          <li><a href="tel:025612277">โทร. 0-2561-2277</a></li>
          <li><a href="mailto:info@acfs.go.th">อีเมล: info&#64;acfs.go.th</a></li>
          <li><a href="#">www.acfs.go.th</a></li>
          <li><a href="#">แผนที่สำนักงาน</a></li>
        </ul>
      </div>
    </div>
    <div class="gov-footer-copy">
      <span>© 2569 ACFS · NATIONAL BUREAU OF AGRICULTURAL COMMODITY AND FOOD STANDARDS</span>
      <div class="gov-footer-copy-links">
        <a href="#">นโยบายความเป็นส่วนตัว</a>
        <span>·</span>
        <a href="#">ข้อกำหนดการใช้งาน</a>
      </div>
    </div>
  </div>
</footer>
